import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/anime';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-heading text-lg">51</span>
              </div>
              <span className="font-heading text-xl text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              51动漫是专业的免费在线动漫平台，提供海量日漫、韩漫、国漫资源，支持下拉式在线阅读，每日更新，收藏追更。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">首页</Link>
              <Link to="/category/riman" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">日漫</Link>
              <Link to="/category/hanman" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">韩漫</Link>
              <Link to="/category/guoman" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">国漫</Link>
              <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/shaonian" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">少年漫</Link>
              <Link to="/category/shaonv" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">少女漫</Link>
              <Link to="/category/qihuan" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">奇幻</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-mail-line text-base"></i>
                <span>{siteInfo.email}</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-phone-line text-base"></i>
                <span>{siteInfo.phone}</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-400 text-sm">
                <i className="ri-map-pin-line text-base"></i>
                <span>{siteInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} {siteInfo.name} 版权所有 | {siteInfo.icp}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}